import React, { FC, useEffect, useState } from 'react';
import Box from '@/components/UI/box/Box';
import styles from './CancellationRules.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import Tabs, { Tab } from '@/components/UI/tabs/Tabs';
import { cancellationTranslate, dayTypesTranslate } from '@/components/houses/_reusable/houseInfo/rules/_constants/rulesConstants';
import Divider from '@/components/UI/divider/Divider';
import CancellationRulesSkeleton from '@/components/houses/_reusable/houseInfo/rules/cancellationRulesSkeleton/CancellationRulesSkeleton';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { fetchCancellationRules } from '@/redux/store/actions/product';
type DaysType = 'normalDay' | 'peakDay' | 'holiday';
type cancellationRulesType = {
  state: string;
  penalty: string;
};
type cancellationType = {
  rules: cancellationRulesType[];
  title: string;
};
type CancellationRulesProps = {
  cancellationRule: 'easy' | 'medium' | 'hard';
  handleClose: VoidFunction;
};
const CancellationRules: FC<CancellationRulesProps> = ({
  cancellationRule,
  handleClose
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const houseId = router.query.id;
  const cancellationRulesData = useSelector(state => state.productReducer.data?.cancellationRules);
  const data: cancellationType[] = cancellationRulesData?.data;
  const loading = cancellationRulesData?.loading;
  const id = cancellationRulesData?.id;
  const [tabValue, setTabValue] = useState<DaysType>('normalDay');
  useEffect(() => {
    if (!data || id !== houseId) dispatch(fetchCancellationRules(cancellationRule, router.query.id as string));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const rulesData = data?.find(item => item.title === dayTypesTranslate[tabValue]);
  return <Box className={styles['cancellation-container']} data-sentry-element="Box" data-sentry-component="CancellationRules" data-sentry-source-file="CancellationRules.tsx">
      <Box className={styles['cancellation-nav']} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
        <Box className={styles['cancellation-header']} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
          <Box className={styles['close-icon']} onClick={handleClose} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
            <Icon name="arrow-right-1" type="highEmphasis" size={'large'} data-sentry-element="Icon" data-sentry-source-file="CancellationRules.tsx" />
          </Box>
          <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="CancellationRules.tsx">قوانین لغو رزرو</Typography>
        </Box>
        <Box className={styles['cancellation-tabs']} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
          <Tabs onChange={newValue => setTabValue(newValue as DaysType)} value={tabValue} data-sentry-element="Tabs" data-sentry-source-file="CancellationRules.tsx">
            <Tab label="روز های عادی" value={'normalDay'} data-sentry-element="Tab" data-sentry-source-file="CancellationRules.tsx" />
            <Tab label="روز های پیک" value={'peakDay'} data-sentry-element="Tab" data-sentry-source-file="CancellationRules.tsx" />
            <Tab label="ایام نوروز" value={'holiday'} data-sentry-element="Tab" data-sentry-source-file="CancellationRules.tsx" />
          </Tabs>
        </Box>
      </Box>

      <Box className={styles['main-content']} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
        <Box className={styles['rule-card']} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
          <Typography className={styles['rule-card-title']} variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="CancellationRules.tsx">
            قوانین این اقامتگاه{' '}
            <Typography variant="bodyL_Bold" data-sentry-element="Typography" data-sentry-source-file="CancellationRules.tsx">
              {cancellationTranslate[cancellationRule]}
            </Typography>{' '}
            می‌باشد.
          </Typography>
          <Divider data-sentry-element="Divider" data-sentry-source-file="CancellationRules.tsx" />
          <Box className={styles['rule-card-description']} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
            <Box className={styles['wrap']} component={'span'} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx"></Box>
            <Box className={styles['description-container']} data-sentry-element="Box" data-sentry-source-file="CancellationRules.tsx">
              {!data || loading ? <CancellationRulesSkeleton /> : rulesData?.rules?.map((rule, index) => <Box key={`RULE_ITEM_${index}`} component={'ul'} className={styles['description-section']}>
                    <Box className={styles['disc']}></Box>
                    <Box className={styles['description-info']}>
                      <Typography component="li" variant="bodyM_Bold">
                        {rule.state}
                      </Typography>
                      <Typography variant="bodyM" color="neutral_main">
                        {rule.penalty}
                      </Typography>
                    </Box>
                  </Box>)}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>;
};
export default CancellationRules;